<div class="content" role="main">
  <router-outlet> </router-outlet>
  <app-spinner [diameter]="100"></app-spinner>
</div>
